"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useMethods_1 = require("./useMethods");
var defaultMethods = [
    { slug: 'visa', src: '/img/payments/banner/visa.svg' },
    { slug: 'mastercard', src: '/img/payments/banner/mc.svg' },
    { slug: 'skrill', src: '/img/payments/banner/skrill.svg' },
    // { slug: 'neteller', src: '/img/payments/neteller.svg' },
];
var PaymentSystems = function () {
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var methods = (0, useMethods_1.useMethods)();
    var getPaymentImagePath = (0, react_1.useCallback)(function (methodSlug) { return "/img/payments/".concat(methodSlug, ".svg"); }, []);
    if (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        (methods || []).map(function (m, idx) {
            var _a, _b;
            return (react_1.default.createElement(react_1.default.Fragment, { key: "method_".concat(m.slug, "_").concat(idx) }, ((_a = m.images) === null || _a === void 0 ? void 0 : _a.logo) ? (react_1.default.createElement("img", { src: (_b = m.images) === null || _b === void 0 ? void 0 : _b.logo, width: 55, height: 35, alt: (m === null || m === void 0 ? void 0 : m.name) || '' })) : (react_1.default.createElement(image_1.default, { key: m.slug, src: getPaymentImagePath(m.slug || ''), width: 55, height: 35, alt: m.slug || '' }))));
        }),
        !methods &&
            defaultMethods.map(function (m, idx) { return (react_1.default.createElement(react_1.default.Fragment, { key: "method_".concat(m.slug, "_").concat(idx) },
                react_1.default.createElement("img", { src: m.src, alt: m.slug, width: 55, height: 35 }))); })));
};
exports.default = PaymentSystems;
